import { OptionModel } from "model/Option.model";

export const initialOptionList = [new OptionModel("10", "10"), new OptionModel("50", "50"), new OptionModel("100", "100")];
